var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showOnboardingOnly)?_c('user-information'):_c('add-Property')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }